<template>
	<div>
		<ManagingSection class="search-by-enter__container">
			<select-input
				ref="report"
				:select-list="reportList"
				:default-select-value="reportTarget"
				@change="reportChange"
				@enter="getSearch()"
				placeholder="회원ID"
			/>
		</ManagingSection>
		<div class="btn-wrap-main">
			<button
				class="btn-main blue"
				type="button"
				@click="onPagination(0)"
			>
				검색
			</button>
			<button
				class="btn-main blue bordered"
				type="button"
				@click="initSearch"
			>
				검색조건 초기화
			</button>
		</div>
		<ManagingSection :isTable="true">
			<template slot="infoSection">
				<div class="section__info__left register-report__summary">
					{{ totalCount }}개 검색됨, 최근 1000개 까지의 데이터만
					조회함
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th>번호</th>
						<th>신고자</th>
						<th>대상</th>
						<th>시각</th>
						<th>사유</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in registerList" :key="item.id">
						<td class="register-report__id">{{ item.id }}</td>
						<td class="register-report__register">
							{{ item.registerId }}({{ item.nickName }})
						</td>
						<td class="register-report__target">
							{{ item.targetRegisterId }}({{
								item.targetRegisterNickName
							}})
						</td>
						<td class="register-report__create">
							{{ item.createdAt }}
						</td>
						<td class="register-report__code">
							{{ item.typeCode }}
							<div
								class="register-report__context"
								v-if="item.contents"
							>
								{{ item.contents }}
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</ManagingSection>
		<PaginationBox
			:limit="limit"
			:offset="offset"
			:totalItem="totalCount"
			slot="pagination"
			@to="onPagination($event.offset)"
			class="register-report__pagination"
		/>
	</div>
</template>
<script>
	import moment from 'moment';
	import ManagingSection from '@/components/layout/ManagingSection';
	import ManagingBox from '@/components/layout/ManagingBox';
	import SearchByEnter from '@/components/extends/SearchByEnter';
	import PaginationBox from '@/components/PaginationBox';
	import SelectInput from '@/components/SelectInput';

	export default {
		name: 'RegisterBlock',
		components: {
			ManagingSection,
			ManagingBox,
			SearchByEnter,
			PaginationBox,
			SelectInput,
		},
		extends: SearchByEnter,
		data() {
			return {
				registerId: '',
				targetRegisterId: '',
				offset: 0,
				limit: 10,
				totalCount: 0,
				reportList: [
					{ value: 'registerId', name: '신고자ID' },
					{ value: 'targetRegisterId', name: '신고대상ID' },
				],
				reportTarget: 'registerId',
				typeCode: {
					RR001: '관련 없는 내용',
					RR002: '의미 없는 내용',
					RR003: '광고/홍보글',
					RR004: '제품 미사용 의심',
					RR005: '욕설/비방',
					RR006: '개인정보 유출',
					RR007: '기타',
					RR008: '음란/선정성',
				},
				registerList: [],
				paramsKey: [
					'offset',
					'limit',
					'registerId',
					'targetRegisterId',
				],
			};
		},
		created() {
			this.getList();
		},
		watch: {
			'$route.query'() {
				this.getList();
				document.getElementById('admin2').scrollTop = 0;
			},
		},
		methods: {
			reportChange({ select, input }) {
				this.reportTarget = select;
				this.reportList.forEach(({ value }) => {
					this[value] = value === select ? input : '';
				});
			},
			getParams() {
				return this.paramsKey.reduce((acc, key) => {
					const value = this[key];
					if (key === 'offset') {
						acc[key] = value || 0;
					} else if (key === 'limit') {
						acc[key] = value || 10;
					} else if (key === 'registerId') {
						acc[key] = value || '';
					} else if (key === 'targetRegisterId') {
						acc[key] = value || '';
					}
					return acc;
				}, {});
			},
			getSearch() {
				const query = this.getParams();
				this.$router.replace({ query }).catch(() => {
					window.location.reload();
				});
			},
			initSearch() {
				this.registerId = '';
				this.targetRegisterId = '';
				this.$refs.report.inputModel = '';
				this.$refs.report.selectModel = 'registerId';
				this.offset = 0;
				this.getSearch();
			},
			async getList() {
				try {
					const params = this.getParams();
					const { data } = await this.$axiosAdmin2.get(
						'/v3/api/register/report/list',
						{ params }
					);
					this.totalCount = data.totalCount;
					this.registerList = data.data;
					this.registerList.forEach(item => {
						item.typeCode = this.typeCode[item.typeCode];
						item.createdAt = moment(item.createdAt * 1000).format(
							'YYYY-MM-DD HH:mm:ss'
						);
					});
				} catch (err) {
					console.error(err);
					alert(
						'리스트를 불러오기에 실패하였습니다. 개발팀에 문의하세요'
					);
				}
			},
			onPagination(offset) {
				this.offset = offset;
				this.getSearch();
			},
		},
	};
</script>
<style lang="scss" scoped>
	#app-main-v3 {
		.table-main {
			width: auto;
		}
	}
	.register-report__summary {
		font-weight: bold;
	}
	.register-report__id {
		width: 80px;
	}
	.register-report__register,
	.register-report__target,
	.register-report__create {
		width: 200px;
	}

	.register-report__code {
		text-align: left;
	}
	.register-report__context {
		margin-top: 10px;
		text-align: left;
		border: 1px solid #ccc;
		border-radius: 4px;
		background: #f5f5f5;
		padding: 10px;
		word-wrap: break-word;
		white-space: pre-wrap;
	}
	.register-report__pagination {
		margin-top: 20px;
	}
</style>
